interface User {
  picture?: string;
  picturePath?: string;
}

export function isNull(canBeNull: any): boolean {
  return canBeNull === undefined || canBeNull === null || canBeNull === "";
}
